module.exports = __webpack_public_path__ + "static/media/fill_form_illustration.18324aff.svg";